import { gql, graphQueryBang } from "shared/lib/graphql"
import { topCategoriesMapper } from "./gql_data_mapper"

const topWorksWithCategoriesQuery = gql`
  query(
    $service: String!
    $current_metric_date: DataServiceDate!
    $limit: Int
  ) {
    current: service_metrics(
      channel_module_name: $service
      metric_start_date: $current_metric_date
      metric_end_date: $current_metric_date
    ) {
      metrics {
        metric_date
        new_users_TIME_PERIOD
        top_works_with_categories_TIME_PERIOD(limit: $limit) {
          category {
            name
            id
          }
          metrics {
            metric_date
            active_users_TIME_PERIOD
            top_services_TIME_PERIOD(limit: 4) {
              user_count
              channel {
                name
                module_name
                brand_color
                monochrome_image_url
              }
            }
          }
        }
      }
    }
  }
`

const singleCategoryQuery = gql`
  query(
    $service: String!
    $daily_metric_start_date: DataServiceDate!
    $current_metric_date: DataServiceDate!
    $category_name: String
  ) {
    daily: service_metrics(
      channel_module_name: $service
      metric_start_date: $daily_metric_start_date
      metric_end_date: $current_metric_date
      category_name: $category_name
    ) {
      category_metrics {
        category {
          name
          id
        }
        metrics {
          metric_date
          active_users_TIME_PERIOD
          service_engagement_daily
        }
      }
      errors {
        attribute
        message
      }
    }
  }
`

const composedTopWorksWithCategoriesQuery = timePeriodMetric =>
  topWorksWithCategoriesQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

const composedSingleCategoryQuery = timePeriodMetric =>
  singleCategoryQuery.replace(/TIME_PERIOD/g, timePeriodMetric)

export default function topCategoriesFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  {
    dailyMetricStartDate,
    currentMetricDate,
    comparisonMetricDate,
    timePeriodInDays,
    timePeriodMetric,
    limit,
  }
) {
  const categoriesP = graphQueryBang(
    composedTopWorksWithCategoriesQuery(timePeriodMetric),
    {
      service: serviceModuleName,
      current_metric_date: currentMetricDate,
      limit,
    }
  )

  const topCategoriesP = categoriesP
    .then(data =>
      data.current.metrics[0][
        `top_works_with_categories_${timePeriodMetric}`
      ].map(worksWithCategory => worksWithCategory.category.name)
    )
    .then(topCategories =>
      Promise.all(
        topCategories.map(category =>
          graphQueryBang(composedSingleCategoryQuery(timePeriodMetric), {
            service: serviceModuleName,
            daily_metric_start_date: dailyMetricStartDate,
            current_metric_date: currentMetricDate,
            category_name: category,
            limit,
          })
        )
      )
    )

  return Promise.all([categoriesP, topCategoriesP]).then(values => {
    const [serviceMetrics, worksWithCategories] = values

    return topCategoriesMapper(
      {
        current: serviceMetrics.current.metrics[0],
        worksWithCategories: worksWithCategories.map(
          wwCategory => wwCategory.daily.category_metrics[0]
        ),
      },
      timePeriodInDays,
      serviceModuleName,
      comparisonMetricDate,
      timePeriodMetric
    )
  })
}
